
import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  GetSettingsRes,
  SetEnrollSettingsReq,
  SetGlobalSettingsReq,
  SetFormatSettingsReq,
  SuccessResponse,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function usePlatformSetting() {
  class PlatformSetting<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerGetSettings
     * @summary Returns platform settings
     * @request GET:/api3/platform-setting
     * @secure
     * @response `200` `GetSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerGetSettings = (
      query?: {
        /** @example "ga_global_settings" */
        group?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSettingsRes, BaseErrorResponse>({
        path: '/api3/platform-setting',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerGetFormatSettings
     * @summary Returns platform format settings
     * @request GET:/api3/platform-setting/format
     * @secure
     * @response `200` `GetSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerGetFormatSettings = (params: RequestParams = {}) =>
      this.request<GetSettingsRes, BaseErrorResponse>({
        path: '/api3/platform-setting/format',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerSetFormatSettings
     * @summary Set platform format settings
     * @request POST:/api3/platform-setting/format
     * @secure
     * @response `200` `GetSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerSetFormatSettings = (data: SetFormatSettingsReq, params: RequestParams = {}) =>
      this.request<GetSettingsRes, BaseErrorResponse>({
        path: '/api3/platform-setting/format',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerGetEnrollSettings
     * @summary Returns platform enroll settings
     * @request GET:/api3/platform-setting/enroll
     * @response `200` `GetSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerGetEnrollSettings = (params: RequestParams = {}) =>
      this.request<GetSettingsRes, BaseErrorResponse>({
        path: '/api3/platform-setting/enroll',
        method: 'GET',
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerSetEnrollSettings
     * @summary Set platform enroll settings
     * @request POST:/api3/platform-setting/enroll
     * @response `200` `SuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerSetEnrollSettings = (data: SetEnrollSettingsReq, params: RequestParams = {}) =>
      this.request<SuccessResponse, BaseErrorResponse>({
        path: '/api3/platform-setting/enroll',
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerGetGlobalSettings
     * @summary Returns platform global settings
     * @request GET:/api3/platform-setting/global
     * @secure
     * @response `200` `GetSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerGetGlobalSettings = (params: RequestParams = {}) =>
      this.request<GetSettingsRes, BaseErrorResponse>({
        path: '/api3/platform-setting/global',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerSetGlobalSettings
     * @summary Set platform global settings
     * @request POST:/api3/platform-setting/global
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerSetGlobalSettings = (data: SetGlobalSettingsReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/platform-setting/global',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerGetSmsSettings
     * @summary Returns platform OTP/2FA settings
     * @request GET:/api3/platform-setting/sms
     * @secure
     * @response `200` `GetSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerGetSmsSettings = (params: RequestParams = {}) =>
      this.request<GetSettingsRes, BaseErrorResponse>({
        path: '/api3/platform-setting/sms',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Platform setting
     * @name PlatformSettingControllerSetSmsSettings
     * @summary Set platform OTP/2FA settings
     * @request POST:/api3/platform-setting/sms
     * @secure
     * @response `200` `SuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    platformSettingControllerSetSmsSettings = (data: SetEnrollSettingsReq, params: RequestParams = {}) =>
      this.request<SuccessResponse, BaseErrorResponse>({
        path: '/api3/platform-setting/sms',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new PlatformSetting();
}
